import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M13.1,8.6h3.3l-0.2,3h-3.1V22H9.3V11.6H7.2v-3h2.1v-2c0-0.9,0-2.2,0.7-3.1C10.6,2.6,11.5,2,13.1,2c2.6,0,3.7,0.4,3.7,0.4 l-0.5,3.1c0,0-0.9-0.2-1.7-0.2c-0.8,0-1.5,0.3-1.5,1.1L13.1,8.6L13.1,8.6z" />,
  'FacebookSimple',
);
